import React from 'react';
import { useSelector } from '@redux';
import { DynamicObjectType } from 'types/commons';
import { get } from 'lodash';
import { TableColumnType } from 'antd';
import { EditOptionsType } from '@redux/crudCreator/types';

export type TTableColumnProps = {
  data?: string;
  record: DynamicObjectType & { id: string; hasNotRender?: boolean };
  index: number;
  model: string;
  name: string;
  isDefault?: boolean;
  render?: (
    columnData: string | number | boolean | DynamicObjectType,
    _record: DynamicObjectType,
    index: number,
    handleEditRow?: (
      data: DynamicObjectType,
      options?: EditOptionsType,
    ) => void,
  ) => React.ReactElement;
  handleEditRow?: (data: DynamicObjectType, options?: EditOptionsType) => void;
};

export interface IRestColumnProps extends TableColumnType<{ id: string }> {
  name: string;
  sorter?: boolean;
  isDefault?: boolean;
  render?: (
    columnData: string | number | boolean | DynamicObjectType,
    _record: DynamicObjectType,
    index: number,
    handleEditRow?: (
      data: DynamicObjectType,
      options?: EditOptionsType,
    ) => void,
  ) => React.ReactElement;
  children?: IRestColumnProps[];
}

export default function TableColumn({
  name,
  model,
  render,
  record,
  index,
  handleEditRow,
}: TTableColumnProps) {
  const _record = record?.hasNotRender
    ? record
    : useSelector<DynamicObjectType>((state) => state[model].data[record.id]);
  const columnData = record?.hasNotRender
    ? get(record, name)
    : useSelector<string | number | boolean>((state) =>
        get(state[model].data[record.id], name),
      );

  return render ? (
    render(columnData, _record || record, index, handleEditRow)
  ) : (
    <div>{columnData}</div>
  );
}
